import Cookies from 'js-cookie'

const state = {
    sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false
    },
    device: 'desktop',
    menuitem: {
        menu: localStorage.getItem("menu") ? JSON.parse(localStorage.getItem("menu")) : null,
        data: sessionStorage.getItem('prevdata') ? JSON.parse(sessionStorage.getItem('prevdata')) : [],
        title: sessionStorage.getItem('title'),
        active: sessionStorage.getItem('active'),
        activeItem: sessionStorage.getItem('activeitem'),
        activeTitle: sessionStorage.getItem('activetitle'),
        prevactive: sessionStorage.getItem('prevactive'),
        prevdata: sessionStorage.getItem('prevdata') ? JSON.parse(sessionStorage.getItem('prevdata')) : [],
        prevtitle: sessionStorage.getItem('prevtitle'),
        prevpath: sessionStorage.getItem('prevpath'),
        haveMenu:sessionStorage.getItem("havemenu")
    }
}

const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened
        state.sidebar.withoutAnimation = false
        if (state.sidebar.opened) {

            Cookies.set('sidebarStatus', 1)
        } else {
            Cookies.set('sidebarStatus', 0)
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0)
        state.sidebar.opened = false
        state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
        state.device = device
    },
    SETMENU: (state, data) => {
        state.menuitem.menu = data.menu
        state.menuitem.haveMenu = data.state
        sessionStorage.setItem('havemenu',data.state)
        localStorage.setItem('menu', JSON.stringify(data.menu))
    },
    SET_ITEMS: (state, data) => {
        let list = data.list.length != 0 ? data.list.map(i => { return i }) : state.menuitem.data
        let title = data.title ? data.title : state.menuitem.title
        let w = document.body.clientWidth
        if (w <= 992 && data.active == 'click')
            data.active = 'hover'
        state.menuitem.data = list
        state.menuitem.title = title
        state.menuitem.active = state.menuitem.active == 'click' ? 'click' : data.active

    },
    ISTITLE_ACTIVE: (state, data) => {
        let w = document.body.clientWidth
        let activeitem = data.list[0].id
        if (data.list[0].items)
            activeitem = data.list[0].items[0].id
        state.menuitem.active = w <= 992 ? '' : data.active

        state.menuitem.prevdata = data.list
        state.menuitem.prevtitle = data.title
        state.menuitem.activeTitle = state.menuitem.title
        state.menuitem.activeItem = activeitem
        state.menuitem.prevpath = data.url

        sessionStorage.setItem('prevdata', JSON.stringify(data.list))
        sessionStorage.setItem('prevtitle', data.title)
        sessionStorage.setItem('prevpath', data.url)
        sessionStorage.setItem('active', data.active)
        sessionStorage.setItem('activeitem', activeitem)
        sessionStorage.setItem('activetitle', data.title)

    },
    CORRECT(state, i) {
        state.menuitem.data = i.d
        state.menuitem.title = i.t
        state.menuitem.active =state.sidebar.withoutAnimation?'':'click'//i.t == '概况' ? '' : 'click'
        state.menuitem.activeItem = i.i.id
        state.menuitem.activeTitle = i.t
        state.menuitem.prevactive = 'click'
        state.menuitem.prevdata = i.d
        state.menuitem.prevtitle = i.t
        sessionStorage.setItem('title', i.t)
        sessionStorage.setItem('active', '')//i.t == '概况' ? '' : 'click'
        sessionStorage.setItem('activeitem', i.i.id)
        sessionStorage.setItem('activetitle', i.t)
        sessionStorage.setItem('prevactive', 'click')
        sessionStorage.setItem('prevdata', JSON.stringify(i.d))
        sessionStorage.setItem('prevtitle', i.t)
    },
    SET_SHOW: (state, data) => {
        let w = document.body.clientWidth
        if (!state.sidebar.opened) {
            state.menuitem.prevactive = state.menuitem.active
            state.menuitem.active = data
            sessionStorage.setItem('active', data)
            sessionStorage.setItem('prevactive', state.menuitem.active)
        } else {
            state.menuitem.active = state.menuitem.prevactive
        }
        if (w <= 992 && state.menuitem.activeTitle)
            state.menuitem.active = 'hover'
    },
    HIDDEN: (state) => {
        state.menuitem.active = ""
        sessionStorage.setItem('active', '')
    },
    CLEAR: (state) => {
        state.menuitem.active = ""
        state.menuitem.activeTitle = ""
        state.menuitem.activeItem = ""
        state.menuitem.prevdata = []
        state.menuitem.prevtitle = ""
        sessionStorage.setItem('active', '')
        sessionStorage.setItem('activeitem', '')
        sessionStorage.setItem('activetitle', '')
        sessionStorage.setItem('prevdata', '')
        sessionStorage.setItem('prevtitle', '')
    },
    SET_ACTIVEITEM: (state, data) => {
        let w = document.body.clientWidth
        if (w <= 992)
            data.active = ''
        state.menuitem.activeItem = data.id
        state.menuitem.activeTitle = state.menuitem.title
        state.menuitem.active = data.active

        sessionStorage.setItem('active', data.active)
        sessionStorage.setItem('activeitem', data.id)
    },
    SET_DATA: (state, data) => {
        var w = document.body.clientWidth
        if (!(data.data instanceof Array))
            data.data = []
        if (data.state == 'save') {
            state.menuitem.prevdata = data.data
            state.menuitem.prevtitle = data.title
            sessionStorage.setItem('activetitle', data.title)
            sessionStorage.setItem('prevdata', JSON.stringify(data.data))
            sessionStorage.setItem('prevtitle', data.title)
        } else if ((state.menuitem.active == 'click' || w <= 992) && data.state == 'active') {
            state.menuitem.data = ((state.menuitem.prevdata instanceof Array) && state.menuitem.prevdata.length != 0) ? state.menuitem.prevdata : state.menuitem.data
            state.menuitem.title = state.menuitem.prevtitle
            state.menuitem.activeTitle = state.menuitem.prevtitle
            sessionStorage.setItem('title', state.menuitem.prevtitle)
        }
    }
}

const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}